<template lang="pug">
include unsupportedbrowser.pug
</template>

<script>
export default {
  name: 'UnsupportedBrowser'
}
</script>
